import { render, staticRenderFns } from "./CentroOncologiaComponente.vue?vue&type=template&id=14a44a77&scoped=true"
import script from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
export * from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroOncologiaComponente.vue?vue&type=style&index=0&id=14a44a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a44a77",
  null
  
)

export default component.exports